import { createFileRoute } from "@tanstack/react-router";
import { RegistrationForm } from "components/Forms/RegistrationForm/RegistrationForm.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const Route = createFileRoute("/auth/_layout/registration/")({
    component: RegistrationPage,
});

function RegistrationPage() {
    const { t: tAuth } = usePaldockTranslation("auth.registration");

    return (
        <AuthPageContainer title={tAuth("title")}>
            <RegistrationForm />
        </AuthPageContainer>
    );
}
